/* globals jQuery */

import lazyLoad from './_lazyLoad';
import navScroll from './_navScroll';
import animecontrol from './_animecontrol';
import nav from './_nav';
import responsivetabs from './_responsivetabs';
import slick from './_slick';
import scrollto from './_scrollto';

function init() {
  lazyLoad();
  navScroll();
  animecontrol();
  nav();
  responsivetabs();
  slick();
  scrollto();
}

init();
